import { BaseAPI } from '../manager/base';
import apiClient from '../apiClient';
import type { BaseResponse } from '../../types/base.dto';
import { TeamEntity } from '../../types/team/team';
import { TeamAuditConfigEntity, TeamAuditConfigMap } from '../../types/team/team_audit_config';

export class TeamAPI extends BaseAPI<TeamEntity> {
  constructor() {
    super('/teams');
  }

  // list is inherited from BaseAPI

  // create is inherited

  // updateById is inherited

  // deleteById is inherited

  getConfigs(teamId: number | string): Promise<BaseResponse<TeamAuditConfigMap>> {
    return apiClient.get<BaseResponse<TeamAuditConfigMap>>(`${this.endpoint}/${teamId}/audit-configs`).then(res => res.data);
  }

  saveConfig(teamId: number | string, config: TeamAuditConfigEntity): Promise<BaseResponse<any>> {
    return apiClient.post<BaseResponse<any>>(`${this.endpoint}/${teamId}/audit-configs`, config).then(res => res.data);
  }

  deleteConfig(teamId: number | string, configId: number | string): Promise<BaseResponse<any>> {
    return apiClient.delete<BaseResponse<any>>(`${this.endpoint}/${teamId}/audit-configs/${configId}`).then(res => res.data);
  }
}

export const teamApi = new TeamAPI();
export default teamApi;
